import React from "react";
import RegisterNavbar from "../../components/registration/RegisterNavbar";
import Register from "../../components/registration/Register";
import Footer from "../../components/common/Footer";

export default function RegisterOrganizationPage() {
  return (
    <>
      <RegisterNavbar />
      <Register />
      <Footer />
    </>
  );
}
